interface PlanBadgeProps {
  plan: 'free' | 'pro'
  size?: 'sm' | 'md'
}

export default function PlanBadge({ plan, size = 'md' }: PlanBadgeProps) {
  const base = size === 'sm'
    ? 'text-[10px] px-1.5 py-0.5 font-semibold rounded-md'
    : 'text-xs px-2.5 py-1 font-semibold rounded-lg'

  if (plan === 'pro') {
    return (
      <span
        className={`inline-flex items-center ${base}`}
        style={{
          background: 'linear-gradient(135deg, #4F46E5, #8B5CF6)',
          color: 'white',
          boxShadow: '0 0 8px rgba(79,70,229,0.4)',
        }}
      >
        Pro
      </span>
    )
  }

  return (
    <span
      className={`inline-flex items-center ${base}`}
      style={{
        background: 'rgba(255,255,255,0.08)',
        color: '#94A3B8',
        border: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      Free
    </span>
  )
}
